import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'FixIosBug'
})
export default class FixIosBug extends Vue {

  get device() {
    return this.$store.state.app.device;
  }

  public fixBugIniOS() {
    const $subMenu: any = this.$refs.subMenu;
    if ($subMenu) {
      // const handleMouseleave = $subMenu.handleMouseleave;
      // $subMenu.handleMouseleave = (e) => {
      //   if (this.device === 'mobile') {
      //     return;
      //   }
      //   handleMouseleave(e);
      // };
    }
  }

  public mounted() {
    // In order to fix the click on menu on the ios device will trigger the mouseleave bug
    this.fixBugIniOS();
  }
}
